import React, { useEffect, useState } from "react"
import Skeleton from "react-loading-skeleton"
import Api from "@/_helpers/Api"
import { trans } from "@/_providers/Translation"
import { LineChart } from "@mui/x-charts"

function AverageRepairTime() {
  const [loading, setLoading] = useState(true)
  const [chartData, setChartData] = useState([])
  const [filters, setFilters] = useState({ category_id: "" })
  const [categories, setCategories] = useState([])
  const [avarage, setAvarage] = useState(null)

  useEffect(() => {
    setLoading(true)

    Api.get(`analytics/average-repair-time?category_id=${filters.category_id}`)
      .then((res) => {
        setChartData(res.data.data)
        setCategories(res.data.categories || [])
        setLoading(false)
        if (filters.category_id === "") {
          setAvarage(res.data.totals[0])
        } else {
          setAvarage(
            res.data.totals.find(
              (t) => t.category_id === filters.category_id,
            ) || 0,
          )
        }
      })
      .catch(() => setLoading(false))
  }, [filters])

  const labels = chartData.map((d) => d.label)
  const counts = chartData.map((d) => d.avg_time_minutes)

  function getIfAnyCustomers() {
    return chartData.some((item) => item.avg_time_minutes > 0)
  }

  function handleFilterChange(e) {
    const { name, value } = e.target

    setFilters((prev) => ({
      ...prev,
      [name]: value,
    }))
  }

  return (
    <div className="average-repair-time-chart">
      <div className="head">
        <h3>{trans("analytics.averageRepairTime")}</h3>
        <div className="right">
          {loading ? (
            <Skeleton height={40} width={140} count={1} />
          ) : (
            <select
              value={filters.category_id || ""}
              name="category_id"
              onChange={handleFilterChange}
            >
              {categories.map((category) => (
                <option key={category.id} value={category.id}>
                  {category.name}
                </option>
              ))}
            </select>
          )}
        </div>
      </div>
      <hr />
      {loading ? (
        <Skeleton height={300} count={1} />
      ) : !getIfAnyCustomers() ? (
        <div
          className="alert info"
          style={{
            marginBottom: 0,
            width: "100%",
          }}
        >
          {trans("messages.noDataFound")}
        </div>
      ) : (
        <>
          <p>{trans("analytics.averageRepairTime")}</p>
          <b>
            {avarage
              ? `${avarage.avg_time_h}${trans("random.hourShort")} ${!avarage.avg_time_m ? "" : trans("random.and")} ${avarage.avg_time_m ? `${avarage.avg_time_m} ${trans("random.min")}` : ""}`
              : `0 ${trans("random.min")}`}
          </b>
          <LineChart
            xAxis={[
              {
                data: labels,
                scaleType: "point",
              },
            ]}
            series={[
              {
                data: counts,
                area: true,
                color: "#4A3AFF",
                showMark: true,
              },
            ]}
            height={287}
            grid={{ horizontal: true }}
            sx={{
              "& .MuiAreaElement-root": {
                fill: "url(#customers-gradient)",
              },
              "& .MuiLineElement-root": {
                strokeWidth: 1,
              },
              "& .MuiMarkElement-root": {
                stroke: "#fff",
                strokeWidth: 1,
                fill: "#4A3AFF",
                r: 5,
              },
              "& .MuiChartsGrid-line": {
                stroke: "#e0e0e0",
                strokeDasharray: "4 2",
              },
            }}
          >
            <defs>
              <linearGradient
                id="customers-gradient"
                x1="0"
                y1="0"
                x2="0"
                y2="1"
              >
                <stop offset="0%" stopColor="#4A3AFF" stopOpacity={0.25} />
                <stop offset="100%" stopColor="#4A3AFF" stopOpacity={0.02} />
              </linearGradient>
            </defs>
          </LineChart>
        </>
      )}
    </div>
  )
}

export default AverageRepairTime
